module.exports = __webpack_public_path__ + "img/rightBottomBlueTick2x.png?a1ae0608b928d3e667a5fe58c555201f";